module.exports = __webpack_public_path__ + "media/assets/svgs/calendarBlue-226dcfc67500ef40ab12e5fa6872f344.svg";